<section class="container">
  <div>
    @if (rows) {
      <input class="search" pInputText type="text" placeholder="Search" [formControl]="searchTerm" />
      <app-table
        class="simple-table"
        responsiveLayout="scroll"
        [columns]="columns"
        [rows]="rows"
        [compact]="true"
        [paginateRows]="pageSizeOptions[0]"
        [rowsPerPageOptions]="pageSizeOptions">
        <table-column field="VIEWURL">
          <ng-template table-cell-template let-value="value" let-column="column" let-row="row">
            <a [href]="row | clientPortalDetailsUrl">
              <button pButton type="button" label="View" class="px-2 py-1"></button>
            </a>
          </ng-template>
        </table-column>
      </app-table>
    } @else {
      Loading...
    }
  </div>
</section>
